import { render, staticRenderFns } from "./DeckGeneralInfo.vue?vue&type=template&id=edf2f2f6"
import script from "./DeckGeneralInfo.vue?vue&type=script&lang=ts"
export * from "./DeckGeneralInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports